import { dapvApi } from 'services/providers/dapv';
import { ApiEmptyRequest, ApiResponse } from 'services/providers/dapv.types';
import {Dashboard} from './dashboard.types';


const dashboardApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        getDashboard: build.mutation<ApiResponse<Dashboard>, ApiEmptyRequest>({
            query: () => {
                return {
                    url: '/app/dashboard',
                    method: 'GET',
                };
            },
            transformResponse: (response: ApiResponse<Dashboard>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
    })
});

export const {
    useGetDashboardMutation
} = dashboardApi;
